/* LazyAnimatedRovoIcon.tsx generated by @compiled/babel-plugin v3.0.1 */
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import Suspense from '@atlaskit/react-ufo/suspense';
const LazyRovoLoadingGif = React.lazy(() => import( /* webpackChunkName: "@atlassian/rovo-platform-ui-components/rovo-loading-gif" */'./RovoLoadingGif'));
export const LazyAnimatedRovoIcon: React.MemoExoticComponent<({
  alt,
  testId,
  width,
  height
}: {
  alt?: string;
  testId?: string;
  width?: string;
  height?: string;
}) => JSX.Element> = React.memo(({
  alt = '',
  testId = '',
  width = '',
  height = ''
}: {
  alt?: string;
  testId?: string;
  width?: string;
  height?: string;
}): JSX.Element => {
  return <Suspense interactionName="rovo-platform-ui-animated-icon" fallback={null}>
				<LazyRovoLoadingGif alt={alt} testId={testId} width={width} height={height} />
			</Suspense>;
});